/* eslint-disable */
import _ from 'underscore';
import Backbone from 'backbone';
import Promise from 'bluebird';
import * as _SharedRepository from '@bingads-webui-campaign-legacy/adextension-shared/service/repository';
import * as _EditorView from '@bingads-webui-campaign-legacy/adextension-location/view/extension-editor';
import previewTemplate from '@bingads-webui-campaign-legacy/adextension-location/template/preview.pug';
import AssociationsEditorBase from '@bingads-webui-campaign-legacy/adextension-associations-editor/view/index';
import dialogDecorator from '@bingads-webui-component-legacy/dialog/dialogDecorator';
import addressSchema from '@bingads-webui-component-legacy/address/addressSchema';
import addressService from '@bingads-webui-component-legacy/address/service/addressService';
import config from '@bingads-webui-component-legacy/config/index';
import rowTemplate from '@bingads-webui-campaign-legacy/adextension-location/template/gridRowTemplate.pug';
import * as _panelDecorator from '@bingads-webui-campaign-react/panel-decorator';
var s$LocationAdExtension = window.globalLegacySchema.get('LocationAdExtension');
var $i18n = window.globalLegacyI18n.get('component/i18n/loader!campaignui/feature/adextensions');
var SharedRepository = _SharedRepository.default;
var EditorView = _EditorView.default;
var panelDecorator = _panelDecorator.panelDecorator;
var dialogOptions = {
  position: 'center',
  maxWidth: 1000
};
var culture = config.get('culture');
function dataProcess(data) {
  return Promise.map(data, function (item) {
    return addressService.load(culture, item.Address.CountryCode).then(function (res) {
      item.Address.CountryName = _.propertyOf(_.find(res.Countries, {
        Key: item.Address.CountryCode
      }))('Value');
      if (!_.isEmpty(item.Address.ProvinceCode)) {
        item.Address.ProvinceName = item.Address.ProvinceCode;
      }
      if (!_.isEmpty(item.Address.ProvinceName)) {
        item.Address.ProvinceCode = _.isEmpty(res.AdminDistricts) ? item.Address.ProvinceName : _.propertyOf(_.find(res.AdminDistricts, {
          Key: item.Address.ProvinceName
        }))('Value');
      }
      return _.pick(item, 'Address', 'CompanyName', 'PhoneNumber', 'Id', 'Scheduling', 'SundayHours', 'MondayHours', 'TuesdayHours', 'WednesdayHours', 'ThursdayHours', 'FridayHours', 'SaturdayHours', 'SpecialHours');
    });
  });
}
var i18nKeys = {
  title: 'AdExtensions_Location_Editor_Title',
  subtitle: 'NewCampaign_AddLocationAdExtension_Subtitle',
  library_title: 'AdExtensions_Location_Editor_Available',
  selected_title: 'AdExtensions_Location_Editor_Selected',
  create_link: 'AdExtensions_Location_Editor_CreateNew',
  create_title: 'AdExtensions_Location_Dialog_Title_Add',
  delete_btn: 'AdExtensions_Location_Editor_Delete',
  delete_confirm: 'AdExtensions_Location_Delete_Warning',
  edit_btn: 'AdExtensions_Location_Editor_Edit',
  edit_title: 'AdExtensions_Location_Dialog_Title_Edit'
};
var view = AssociationsEditorBase.extend({
  initialize: function (options) {
    var Editor = options && options.usePanel ? panelDecorator(EditorView, {
      i18n: $i18n,
      panelReadyAriaLabel: $i18n.getString('Association editor side panel opened'),
      panelClassName: options.panelClassName
    }) : dialogDecorator.decorate(EditorView, dialogOptions);
    _.extend(options || ({}), {
      data: new SharedRepository({
        schema: s$LocationAdExtension,
        extensionDataFormatter: dataProcess,
        associationsDataFormatter: function (data) {
          return dataProcess(_.pluck(data, 'AdExtension'));
        },
        afterChangeComitted: function () {
          if (_.isFunction(options.updateContext)) {
            options.updateContext(['AccountAdExtensionsGrid', 'CampaignAdExtensionsGrid', 'AdGroupAdExtensionsGrid']);
          }
        }
      }),
      template: {
        preview: previewTemplate,
        rowTemplate: rowTemplate
      },
      extensionType: 'LocationExtension',
      CreateForm: Editor,
      EditForm: Editor,
      i18nKeys: _.extend({}, i18nKeys, options.i18nKeys || ({})),
      processItem: function (item) {
        item.display = addressSchema.display(item.Address);
        return item;
      }
    });
    AssociationsEditorBase.prototype.initialize.call(this, options);
  }
});
export default view;

